import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom'; 
import Navbar from '../../../commonComponents/Navbar';
import Footer from '../../../commonComponents/Footer';
import './BlogData.css';
import moment from 'moment';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const BlogData = () => {
    const { Slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [recentBlogs, setRecentBlogs] = useState([]);

    // Scroll to top when the component is mounted
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [Slug]);

    useEffect(() => {
        const fetchBlogDetails = async () => {
            try {
                const response = await fetch(`https://blueberry-travel.com/blog2/${Slug}`, {
                    method: 'GET',
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to fetch: ${response.status} - ${errorText}`);
                }

                const data = await response.json();
                setBlog(data[0]);
            } catch (error) {
                setError(error.message);
                console.error("Error fetching blog details: ", error);
            } finally {
                setLoading(false);
            }
        };

        const fetchRecentBlogs = async () => {
            try {
                const response = await fetch('https://blueberry-travel.com/blog1/List1', { method: 'GET' });
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to fetch recent blogs: ${response.status} - ${errorText}`);
                }
                const data = await response.json();
                setRecentBlogs(data.slice(0, 3)); // Get only the top 3 recent blogs
            } catch (error) {
                setError(error.message);
                console.error("Error fetching recent blogs: ", error);
            }
        };

        fetchBlogDetails();
        fetchRecentBlogs();
    }, [Slug]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const truncateWords = (html, wordLimit) => {
        if (!html) return '';
        const div = document.createElement('div');
        div.innerHTML = html;
        const text = div.textContent || div.innerText;
        const words = text.split(/\s+/);
        const truncatedText = words.slice(0, wordLimit).join(' ');
        return truncatedText.length < text.length ? `${truncatedText}...` : truncatedText;
    };

    return (
        <>
            <Navbar />
            <div className="blog-detail innerBlogPageDetails">
                {blog ? (
                    <>
                        {/* Banner Image */}
                        {blog.BannerImage && (
                            <div className="blog-bannerInner" style={{marginTop: "-47px" , width: "100%"}}>
                                <img
                                    effect="blur"
                                    src={blog.BannerImage}
                                    alt="Blog Banner"
                                    loading="lazy" 
                                    className="img-fluid w-100"
                                    style={{ width: "100%", height: "100%"}}
                                />
                            </div>
                        )}
                        <div className='container'>
                            {/* Blog Title */}
                            <h1
                                className="headings mt-5"
                                dangerouslySetInnerHTML={{ __html: blog.Title }}
                            />

                            {/* Short Description */}
                            {blog.ShortDescription && (
                                <div
                                    className="short-description mt-4"
                                    dangerouslySetInnerHTML={{ __html: blog.ShortDescription }}
                                />
                            )}

                            {/* Detailed Description */}
                            {blog.Description && (
                                <div
                                    className="content mt-4 bbtBlogInnerImg"
                                    dangerouslySetInnerHTML={{ __html: blog.Description }}
                                />
                            )}
                        </div>
                    </>
                ) : (
                    <p>Blog not found or loading...</p>
                )}
            </div>

            {/* Recent Blogs Section */}
            <div className="container recent-blogs mt-5">
                <h3 className="headings" style={{ fontSize: "40px", textAlign: "center" }}><span> Read More </span> Our Recent Blogs</h3>
                <div className="row mt-4 blog-inner-card-div" >
                    {recentBlogs.map((blog) => {
                        const formattedDate = moment(blog.CreatedDate, 'MMM DD YYYY hh:mmA').format('MMM DD, YYYY');

                        return (
                            <div key={blog.ArticleId} className="col-lg-4 col-md-6 mb-4 blogInnerRecentCards">
                                <div className="card blogInnerRecentCards" style={{ width: '100%' }}>
                                    <LazyLoadImage
            effect="blur"

                                        src={blog.Thumbnail}
                                        loading="lazy" 
                                        alt={blog.Title}
                                        className="card-img-top blogInnerRecentDiv"
                                    />

                                    <div className="card-body blogInnerRecentCards" style={{ backgroundColor: "white", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", border: "none !important" }}>
                                        <h5 className="card-title headings">
                                            {truncateWords(blog.Title, 9)} {/* Truncate title to 9 words */}
                                        </h5>

                                        {blog.ShortDescription && (
                                            <div
                                                className="short-description mt-4 blogRecentPara"
                                                dangerouslySetInnerHTML={{ __html: truncateWords(blog.ShortDescription, 30) }}
                                            />
                                        )}


                                        <div class="calendar d-flex gap-2 align-items-center ">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/calendar2.svg" alt="Calendar Icon" loading="lazy" />

                                            <p class="mt-3 p" > <small style={{ color: "rgb(2, 97, 158)" }}>{formattedDate}</small></p>
                                        </div>

                                        <Link to={`/blog/${blog.Slug}`} className="btn carouselCaptionbutton text-uppercase blogss" style={{ width: "100%" }}>
                                            Read More
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <Footer />
        </>
    );
};

export default BlogData;
